import { LocalStorage, StorageKeyType } from '../Storage/Storage';

export class GridStorageHelper {
    public static getGridTotalBoxVisibility(): boolean {
        const value = LocalStorage.getItem(StorageKeyType.isGridTotalBoxVisible) as boolean | undefined;

        if (value === undefined) {
            return true;
        }

        return value;
    }

    public static getOnlyFavoriteCampaignsSetting(): boolean {
        const value = LocalStorage.getItem(StorageKeyType.isOnlyFavoriteCampaignsVisible) as boolean | undefined;

        if (value === undefined) {
            return false;
        }

        return value;
    }

    public static setGridTotalBoxVisibility(value: boolean): boolean {
        LocalStorage.setItem(StorageKeyType.isGridTotalBoxVisible, value);

        return value;
    }

    public static setOnlyFavoriteCampaignsSetting(value: boolean): boolean {
        LocalStorage.setItem(StorageKeyType.isOnlyFavoriteCampaignsVisible, value);

        return value;
    }

    public static getCompactViewEnabled(): boolean {
        const isCompactViewEnabled = LocalStorage.getItem(StorageKeyType.isCompactViewEnabled) as boolean | undefined;

        if (isCompactViewEnabled === undefined) {
            return true;
        }

        return isCompactViewEnabled;
    }

    public static setCompactViewEnabled(isCompactViewEnabled: boolean): boolean {
        LocalStorage.setItem(StorageKeyType.isCompactViewEnabled, isCompactViewEnabled);

        return isCompactViewEnabled;
    }
}
